{
  "roleId": "role-610000-mfrs",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-610000",
  "label": "[610000] Statement of changes in equity (MFRS)",
  "taxonomy": "FS-MFRS",
  "sheetId": "StatementOfChangesInEquity",
  "description": "Statement showing movements in equity components during the financial year - MFRS",
  "columnSumValidations": [
    {
      "subTotalColumnQname": "ifrs-full:NonDistributableReservesMember",
      "componentColumnQnames": [
        "ifrs-full:CapitalReserveMember",
        "ifrs-full:ReserveOfGainsAndLossesOnHedgingInstrumentsThatHedgeInvestmentsInEquityInstrumentsMember",
        "ifrs-full:ForeignCurrencyTranslationReserveMember",
        "ifrs-full:ReserveOfSharebasedPaymentsMember",
        "ifrs-full:RevaluationSurplusMember",
        "ifrs-full:StatutoryReserveMember",
        "ifrs-full:WarrantReserveMember",
        "ifrs-full:OtherNondistributableReserveMember"
      ],
      "subTotalLabel": "Sub-total of non-distributable reserves",
      "componentLabels": [
        "Capital reserve",
        "Hedging reserve",
        "Foreign currency translation reserve",
        "Reserve of share-based payments",
        "Revaluation surplus",
        "Statutory reserve",
        "Warrant reserve",
        "Other non-distributable reserves"
      ],
      "appliesToRowQnames": [
        "ifrs-full:Equity:Beginning",
        "ssmt-mfrs:ImpactOfChangeInAccountingStandards",
        "ssmt-mfrs:EquityBalanceRestated",
        "ifrs-full:ProfitLoss",
        "ifrs-full:OtherComprehensiveIncome",
        "ifrs-full:ComprehensiveIncome",
        "ifrs-full:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
        "ifrs-full:DividendsPaid",
        "ifrs-full:IssueOfEquity",
        "ifrs-full:IssueOfConvertibleInstruments",
        "ifrs-full:IncreaseDecreaseThroughSharebasedPaymentTransactions",
        "ifrs-full:IncreaseDecreaseThroughTreasuryShareTransactions",
        "ifrs-full:IncreaseDecreaseThroughTransactionsWithOwners",
        "ifrs-full:IncreaseDecreaseThroughTransfersAndOtherChangesEquity",
        "ifrs-full:ChangesInEquity",
        "ifrs-full:Equity:End"
      ]
    },
    {
      "subTotalColumnQname": "ifrs-full:EquityAttributableToOwnersOfParentMember",
      "componentColumnQnames": [
        "ifrs-full:OtherReservesMember",
        "ifrs-full:IssuedCapitalMember",
        "ifrs-full:RetainedEarningsMember",
        "ifrs-full:TreasurySharesMember"
      ],
      "subTotalLabel": "Equity attributable to owners",
      "componentLabels": [
        "Reserves",
        "Issued capital",
        "Retained earnings",
        "Treasury shares"
      ],
      "appliesToRowQnames": [
        "ifrs-full:Equity:Beginning",
        "ssmt-mfrs:ImpactOfChangeInAccountingStandards",
        "ssmt-mfrs:EquityBalanceRestated",
        "ifrs-full:ProfitLoss",
        "ifrs-full:OtherComprehensiveIncome",
        "ifrs-full:ComprehensiveIncome",
        "ifrs-full:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
        "ifrs-full:DividendsPaid",
        "ifrs-full:IssueOfEquity",
        "ifrs-full:IssueOfConvertibleInstruments",
        "ifrs-full:IncreaseDecreaseThroughSharebasedPaymentTransactions",
        "ifrs-full:IncreaseDecreaseThroughTreasuryShareTransactions",
        "ifrs-full:IncreaseDecreaseThroughTransactionsWithOwners",
        "ifrs-full:IncreaseDecreaseThroughTransfersAndOtherChangesEquity"
      ]
    },
    {
      "subTotalColumnQname": "ifrs-full:OtherReservesMember",
      "componentColumnQnames": [
        "ifrs-full:NonDistributableReservesMember",
        "ifrs-full:DistributableReservesMember"
      ],
      "subTotalLabel": "Reserves",
      "componentLabels": [
        "Sub-total of non-distributable reserves",
        "Sub-total of distributable reserves"
      ],
      "appliesToRowQnames": [
        "ifrs-full:Equity:Beginning",
        "ssmt-mfrs:ImpactOfChangeInAccountingStandards",
        "ssmt-mfrs:EquityBalanceRestated",
        "ifrs-full:ProfitLoss",
        "ifrs-full:OtherComprehensiveIncome",
        "ifrs-full:ComprehensiveIncome",
        "ifrs-full:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
        "ifrs-full:DividendsPaid",
        "ifrs-full:IssueOfEquity",
        "ifrs-full:IssueOfConvertibleInstruments",
        "ifrs-full:IncreaseDecreaseThroughSharebasedPaymentTransactions",
        "ifrs-full:IncreaseDecreaseThroughTreasuryShareTransactions",
        "ifrs-full:IncreaseDecreaseThroughTransactionsWithOwners",
        "ifrs-full:IncreaseDecreaseThroughTransfersAndOtherChangesEquity"
      ]
    },
    {
      "subTotalColumnQname": "ifrs-full:DistributableReservesMember",
      "componentColumnQnames": [
        "ifrs-full:FairValueAdjustmentReserveMember",
        "ifrs-full:ConsolidatedReserveMember",
        "ifrs-full:WarrantyReserveMember",
        "ifrs-full:ReserveOfNoncurrentAssetsClassifiedAsHeldForSaleMember",
        "ifrs-full:OtherDistributableReserveMember"
      ],
      "subTotalLabel": "Sub-total of distributable reserves",
      "componentLabels": [
        "Fair value reserve",
        "Consolidation reserve",
        "Warranty reserve",
        "Reserve of non-current assets classified as held for sale",
        "Other distributable reserves"
      ],
      "appliesToRowQnames": [
        "ifrs-full:Equity:Beginning",
        "ssmt-mfrs:ImpactOfChangeInAccountingStandards",
        "ssmt-mfrs:EquityBalanceRestated",
        "ifrs-full:ProfitLoss",
        "ifrs-full:OtherComprehensiveIncome",
        "ifrs-full:ComprehensiveIncome",
        "ifrs-full:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
        "ifrs-full:DividendsPaid",
        "ifrs-full:IssueOfEquity",
        "ifrs-full:IssueOfConvertibleInstruments",
        "ifrs-full:IncreaseDecreaseThroughSharebasedPaymentTransactions",
        "ifrs-full:IncreaseDecreaseThroughTreasuryShareTransactions",
        "ifrs-full:IncreaseDecreaseThroughTransactionsWithOwners",
        "ifrs-full:IncreaseDecreaseThroughTransfersAndOtherChangesEquity",
        "ifrs-full:ChangesInEquity",
        "ifrs-full:Equity:End"
      ]
    }
  ],
  "equityColumns": [
    {
      "qname": "ifrs-full:IssuedCapitalMember",
      "label": "Issued capital",
      "order": 1
    },
    {
      "qname": "ifrs-full:RetainedEarningsMember",
      "label": "Retained earnings",
      "order": 2
    },
    {
      "qname": "ifrs-full:TreasurySharesMember",
      "label": "Treasury shares",
      "order": 3
    },
    {
      "qname": "ifrs-full:CapitalReserveMember",
      "label": "Capital reserve",
      "order": 4
    },
    {
      "qname": "ifrs-full:ReserveOfGainsAndLossesOnHedgingInstrumentsThatHedgeInvestmentsInEquityInstrumentsMember",
      "label": "Hedging reserve",
      "order": 5
    },
    {
      "qname": "ifrs-full:ForeignCurrencyTranslationReserveMember",
      "label": "Foreign currency translation reserve",
      "order": 6
    },
    {
      "qname": "ifrs-full:ReserveOfSharebasedPaymentsMember",
      "label": "Reserve of share-based payments",
      "order": 7
    },
    {
      "qname": "ifrs-full:RevaluationSurplusMember",
      "label": "Revaluation surplus",
      "order": 8
    },
    {
      "qname": "ifrs-full:StatutoryReserveMember",
      "label": "Statutory reserve",
      "order": 9
    },
    {
      "qname": "ifrs-full:WarrantReserveMember",
      "label": "Warrant reserve",
      "order": 10
    },
    {
      "qname": "ifrs-full:OtherNondistributableReserveMember",
      "label": "Other non-distributable reserves",
      "order": 11
    },
    {
      "qname": "ifrs-full:NonDistributableReservesMember",
      "label": "Sub-total of non-distributable reserves",
      "order": 12
    },
    {
      "qname": "ifrs-full:FairValueAdjustmentReserveMember",
      "label": "Fair value reserve",
      "order": 13
    },
    {
      "qname": "ifrs-full:ReserveOfNoncurrentAssetsClassifiedAsHeldForSaleMember",
      "label": "Reserve of non-current assets classified as held for sale",
      "order": 14
    },
    {
      "qname": "ifrs-full:ConsolidatedReserveMember",
      "label": "Consolidation reserve",
      "order": 15
    },
    {
      "qname": "ifrs-full:WarrantyReserveMember",
      "label": "Warranty reserve",
      "order": 16
    },
    {
      "qname": "ifrs-full:OtherDistributableReserveMember",
      "label": "Other distributable reserves",
      "order": 17
    },
    {
      "qname": "ifrs-full:DistributableReservesMember",
      "label": "Sub-Total of distributable reserves",
      "order": 18
    },
    {
      "qname": "ifrs-full:OtherReservesMember",
      "label": "Reserves",
      "order": 19
    },
    {
      "qname": "ifrs-full:EquityAttributableToOwnersOfParentMember",
      "label": "Equity attributable to owners",
      "order": 20
    },
    {
      "qname": "ifrs-full:OtherComponentsOfEquityMember",
      "label": "Equity, others components",
      "order": 21
    },
    {
      "qname": "ifrs-full:NoncontrollingInterestsMember",
      "label": "Non-controlling interests",
      "order": 22
    },
    {
      "qname": "ifrs-full:EquityMember",
      "label": "Total",
      "order": 23
    }
  ],
  "controls": [
    {
      "qname": "ifrs-full:StatementOfChangesInEquityAbstract",
      "label": "Statement of changes in equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:StatementOfChangesInEquityHeader",
      "label": "Statement of changes in equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:Equity:Beginning",
      "label": "Equity at beginning of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "required": true
      },
      "validation": {
        "dataType": "decimal",
        "consecutiveYearEquity": {
          "compareField": "ifrs-full:Equity:End",
          "sheet": "statementOfChangesInEquity"
        },
        "consecutiveYearEquityTotal": {
          "compareField": "ifrs-full:Equity:End",
          "sheet": "statementOfChangesInEquity"
        }
      }
    },
    {
      "qname": "ssmt-mfrs:ImpactOfChangeInAccountingStandards",
      "label": "Impact of changes in accounting policies",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ssmt-mfrs:EquityBalanceRestated",
      "required": true,
      "label": "Equity at beginning of period, restated",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-full:ChangesInEquityAbstract",
      "label": "Changes in equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:ComprehensiveIncomeAbstract",
      "label": "Comprehensive income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:ProfitLoss",
      "label": "Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-full:ProfitLoss"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncome",
      "label": "Total other comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-full:OtherComprehensiveIncome"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:ComprehensiveIncome",
      "required": true,
      "label": "Total comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-full:ComprehensiveIncome"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:ContributionsByAndDistributionsToOwnersAbstract",
      "label": "Contributions by and distributions to owners",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseThroughAcquisitionOfSubsidiary",
      "label": "Acquisition (dilution) of equity interest in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
      "label": "Arising from conversion of Irredeemable Convertible Unsecured Loan Stock (ICULS)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:DividendsPaid",
      "label": "(-) Dividends paid",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "note": "Enter as negative value"
      }
    },
    {
      "qname": "ifrs-full:IssueOfEquity",
      "label": "Issuance of shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:IssueOfConvertibleInstruments",
      "label": "Issue of convertible notes, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseThroughSharebasedPaymentTransactions",
      "label": "Increase (decrease) through share-based payment transactions, equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseThroughTreasuryShareTransactions",
      "label": "Treasury shares transactions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseThroughTransactionsWithOwners",
      "label": "Other transactions with owners",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseThroughTransfersAndOtherChangesEquity",
      "label": "Increase (decrease) through other changes, equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-full:ChangesInEquity",
      "required": true,
      "label": "Total increase (decrease) in equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-full:Equity:End",
      "label": "Equity at end of period",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true,
        "required": true
      },
      "validation": {
        "dataType": "decimal",
        "crossSheetEquityByYear": {
          "compareField": "ifrs-full:Equity",
          "sheet": "statementOfFinancialPosition"
        }
      }
    }
  ]
}
